const n = (() => {
  let e = Date.now();
  return (t = "adyen-pe") => `${t}-${++e}`;
})();
export {
  n as default,
  n as uniqueId
};
